import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { ImageWithBasePath } from 'Core/components';
import Select from 'react-select';
import { actions as productionActions } from './store/slice';
import { selectProductionFilterVisible } from './store/selectors';

const { setFilterVisible, setSearchText } = productionActions;

const ProductionSearch = () => {
  const dispatch = useDispatch();
  const filterVisible = useSelector(selectProductionFilterVisible);
  const [searchText, setSearchTextValue] = useState('');

  const handleSearch = e => {
    const newSearchText = e.target.value;
    setSearchTextValue(newSearchText);

    // let searchTimeout;
    // clearTimeout(searchTimeout);
    // searchTimeout = setTimeout(() => {
    dispatch(setSearchText(newSearchText));
    // }, 300);
  };

  const toggleFilterVisibility = () => {
    const newVisibility = !filterVisible;
    dispatch(setFilterVisible(newVisibility));
  };

  const oldandlatestvalue = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];

  return (
    <>
      <div className="search-set">
        <div className="search-input">
          <Link to="#" className="btn btn-searchset">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-search"
            >
              <circle cx={11} cy={11} r={8} />
              <line x1={21} y1={21} x2="16.65" y2="16.65" />
            </svg>
          </Link>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              {' '}
              <input
                type="search"
                className="form-control form-control-sm"
                placeholder="Search"
                aria-controls="DataTables_Table_0"
                value={searchText}
                onChange={handleSearch}
              />
            </label>
          </div>
        </div>
      </div>
      <div className="search-path">
        <Link className={`btn btn-filter ${filterVisible ? 'setclose' : ''}`} id="filter_search">
          <Filter className="filter-icon" onClick={toggleFilterVisibility} />
          <span onClick={toggleFilterVisibility}>
            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
          </span>
        </Link>
      </div>
      <div className="form-sort" style={{ display: 'none' }}>
        <Sliders className="info-img" />
        <Select
          className="img-select"
          classNamePrefix="react-select"
          options={oldandlatestvalue}
          placeholder="Newest"
        />
      </div>
    </>
  );
};

export default ProductionSearch;
